export default "__VITE_ASSET__rrF4MYqo__"